import { IProduct } from 'shared/map-search/types/analytics';
import { EDealType, EEntityType } from 'shared/map-search/types/chatModal';
import { ITypedReduxAction } from 'shared/map-search/types/redux/actionType';

export enum EChatModalOnMapActionType {
  Open = 'chatModalOnMap/open',
}

export interface IOpenChatModalOnMapPayload {
  gaLabel: string;
  offerId: number;
  defaultMessage?: string;
  dealType?: EDealType;
  offerType?: EEntityType;
  authorId?: number | null;
  product?: IProduct;
}

export type TChatModalOpen = ITypedReduxAction<EChatModalOnMapActionType.Open, IOpenChatModalOnMapPayload>;

export type TChatModalActions = TChatModalOpen;
